import { Tokens } from '@/assets/tokens'
import styled, { css, keyframes } from 'styled-components'

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  width: 100%;
  border-radius: ${Tokens.RadiusInput};
`

export const MentionsFilterContainer = styled.div`
  background-color: white;
  align-items: center;
  border-radius: ${Tokens.RadiusInput};
  width: 100%;
  min-width: 1080px;
  overflow: visible;
  position: relative;

  @media (max-width: 1230px) {
    min-width: 1080px;
    overflow-x: auto;
  }
`

export const MentionsFilterItemContainer = styled.div`
  border-bottom: 1px solid #ddd;
  align-items: center;
  &:last-child {
    border-bottom: none;
  }
  width: 100%;
  min-width: 1080px;
  overflow: visible;
`

export const MentionsFilterHeader = styled.div`
  border-radius: ${Tokens.RadiusInput};
  width: 100%;
  min-width: 1080px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  flex-direction: column;
  overflow: visible;

  h2 {
    margin: 0;
    font-size: 1em;
    font-weight: normal;
  }
`

const hideTransition = keyframes`
  from {
    opacity: 1;
    display: flex;
    visibility: visible;
  }
  to {
    opacity: 0;
    display: none;
    visibility: collapse;
  }
`

const showTransition = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const InvisibleArea = styled.div<{ $isOpen: boolean }>`
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  align-items: stretch;
  gap: 12px;
  animation: ${hideTransition} 0.2s ease-out forwards;
  overflow: visible;
  position: relative;
  padding-top: 12px;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      display: flex;
      opacity: 1;
      animation: ${showTransition} 0.2s ease-in forwards;
    `}
`

export const FilterGroupLine = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  min-width: 1050px;
  box-sizing: border-box;
  flex-wrap: nowrap;
  gap: 10px;
  overflow: visible;
`

export const SwitchLabel = styled.span`
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  font-weight: 400;
  line-height: 1.4;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`

export const ClearFiltersButton = styled.button<{ disabled?: boolean }>`
  color: ${({ disabled }) => (disabled ? Tokens.ColorBackgroundTertiary : Tokens.ColorTextQuaternary)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background: none;
  border: none;
  padding: 0;
  outline: none;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition:
    color 0.2s ease,
    opacity 0.2s ease;

  &:hover:not(:disabled) {
    color: ${Tokens.ColorTextTertiary};
  }
`

export const FilterHeaderContainer = styled.div`
  width: 99.5%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
`

export const FilterActionsContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${Tokens.ColorUIPrimary};
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  outline: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`

export const ToggleAccordionButton = styled.button`
  display: flex;
  gap: 2px;
  cursor: pointer;
  color: ${Tokens.ColorTextQuaternary};
  background: none;
  border: none;
  padding: 0;
  outline: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`

export const ToggleText = styled.span`
  color: ${Tokens.ColorUIPrimary};
`

export const MainFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`

export const TimeInputContainer = styled.div`
  max-width: 120px;
`

export const AccordionIcon = styled.span`
  font-size: 1.5em;
`
